import React from 'react';
import LegalPageLayout from '../components/landing/LegalPageLayout';
import TermsContent from '../components/legal/TermsContent';

export default function TermosPage() {
  return (
    <LegalPageLayout title="Termos e Condições de Uso" lastUpdated="01 de Junho de 2025">
      <TermsContent />
    </LegalPageLayout>
  );
}
